import { render, staticRenderFns } from "./roleTemplate.vue?vue&type=template&id=5380c9a6&scoped=true&"
import script from "./roleTemplate.vue?vue&type=script&lang=js&"
export * from "./roleTemplate.vue?vue&type=script&lang=js&"
import style0 from "./roleTemplate.vue?vue&type=style&index=0&id=5380c9a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5380c9a6",
  null
  
)

export default component.exports